import React from "react";
import CustomLabelCenter from "@common-components/graphs/doughnut-graph/CustomLabelCenter";
import "@common-components/cards/DarkCard.scss";

const CustomMemooizedLabelCenter = React.memo(CustomLabelCenter);

const FilletInformationList = ({
  filletInformation,
  colorGradingInfo,
  getMonitorAverage,
}) => {
  // console.log(filletInformation,'filletInformation')
  const renderField = (label, leftValue, rightValue, averageValue, unit) => {
    // const truncatedLabel =
    //   label.length > 18 ? `${label.substring(0, 18)}...` : label;

    const isValidNumber = (val) => val !== null && val !== undefined;

    return (
      <tr className="odd:bg-gray-100 even:bg-gray-50 dark-bg">
        <td className="px-3 font-semibold relative">
          {/* Tooltip container */}
          <div className="group inline-block">
            <span className="inline-block font-medium overflow-hidden whitespace-nowrap">
              {label}
            </span>
            {label.length > 10 && (
              <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-black text-white text-xs px-2 py-1 rounded whitespace-nowrap">
                {label}
              </div>
            )}
          </div>
        </td>

        {/* Left Value */}
        <td className="px-3">
          {filletInformation?.filletDetails?.leftLane && (
            <div className="flex items-center">
              {isValidNumber(averageValue) && isValidNumber(leftValue) && (
                <>
                  {averageValue > leftValue && (
                    <span className="text-red-500"><i class="ri-arrow-down-s-fill text-[25px]"></i></span>
                  )}
                  {averageValue < leftValue && (
                    <span className="text-green-500"><i class="ri-arrow-up-s-fill text-[25px]"></i></span>
                  )}
                </>
              )}
              {isValidNumber(leftValue)
                ? `${leftValue}${unit ? unit : ""}`
                : "-"}
            </div>
          )}
        </td>

        {/* Right Value */}
        <td className="px-3">
          {filletInformation?.filletDetails?.rightLane && (
            <div className="flex items-center">
              {isValidNumber(averageValue) && isValidNumber(rightValue) && (
                <>
                  {averageValue > rightValue && (
                    <span className="text-red-500"><i class="ri-arrow-down-s-fill text-[25px]"></i></span>
                  )}
                  {averageValue < rightValue && (
                    <span className="text-green-500"><i class="ri-arrow-up-s-fill text-[25px]"></i></span>
                  )}
                </>
              )}
              {isValidNumber(rightValue)
                ? `${rightValue}${unit ? unit : ""}`
                : "-"}
              {/* {isValidNumber(rightValue) && <sup>2</sup>} */}
            </div>
          )}
        </td>
      </tr>
    );
  };

  return (
    <React.Fragment>
       <div
          style={{ display: colorGradingInfo ? "flex" : "none" }}
          className="w-full flex items-center justify-center dark-bg mt-3"
        >
          <CustomMemooizedLabelCenter colorGradingRatio={colorGradingInfo} />
        </div>
      <div className="w-full rounded-md bg-[#eeeeee] overflow-hidden mt-3 border dark-bg">
        <>
          <div className="w-full p-3 flex items-center justify-between border-b border-gray-200 dark-bg">
            <p className="mb-0 text-[20px]">Fillet Information</p>
            <p className="mb-0">
              PID:{" "}
              {filletInformation?.filletDetails?.processedProductID
                ? filletInformation?.filletDetails?.processedProductID
                : "-"}
            </p>
          </div>
          
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-gray-50 light-bg">
                <tr>
                  <th className="px-3 py-2 font-semibold text-left">
                    Attribute
                  </th>
                  <th className="px-2 py-2 font-semibold">Left Lane</th>
                  <th className="px-3 py-2 font-semibold">Right Lane</th>
                </tr>
              </thead>
              <tbody>
                {renderField(
                  "Fillet Length",
                  filletInformation?.filletDetails?.filletLength,
                  filletInformation?.filletDetails?.filletLength,
                  getMonitorAverage?.FilletLength,
                  "cm"
                )}
                {renderField(
                  "Fillet Width",
                  filletInformation?.filletDetails?.filletWidth,
                  filletInformation?.filletDetails?.filletWidth,
                  getMonitorAverage?.FilletWidth,
                  "cm"
                )}
                {renderField(
                  "Raw Fillet Weight",
                  filletInformation?.filletDetails?.rawFilletWeight,
                  filletInformation?.filletDetails?.rawFilletWeight,
                  getMonitorAverage?.RawFilletWeight,
                  "kg"
                )}
                {renderField(
                  "Raw Melanin Spots Loin",
                  filletInformation?.filletDetails?.rawMelaninSpotsLoin,
                  filletInformation?.filletDetails?.rawMelaninSpotsLoin,
                  getMonitorAverage?.RawMelaninSpotsLoin,
                  "cm²"
                )}
                {renderField(
                  "Raw Melanin Spots Belly",
                  filletInformation?.filletDetails?.rawMelaninSpotsBelly,
                  filletInformation?.filletDetails?.rawMelaninSpotsBelly,
                  getMonitorAverage?.RawMelaninSpotsBelly,
                  "cm²"
                )}
                {renderField(
                  "Raw Melanin Spots Tail",
                  filletInformation?.filletDetails?.rawMelaninSpotsTail,
                  filletInformation?.filletDetails?.rawMelaninSpotsTail,
                  getMonitorAverage?.RawMelaninSpotsTail,
                  "cm²"
                )}
                {renderField(
                  "Raw Largest Melanin Spot",
                  filletInformation?.filletDetails?.rawLargestMelaninSpot,
                  filletInformation?.filletDetails?.rawLargestMelaninSpot,
                  getMonitorAverage?.RawLargestMelaninSpot,
                  "cm²"
                )}
                {renderField(
                  "Raw Blood Spots Loin",
                  filletInformation?.filletDetails?.rawBloodSpotsLoin,
                  filletInformation?.filletDetails?.rawBloodSpotsLoin,
                  getMonitorAverage?.RawBloodSpotsLoin,
                  "cm²"
                )}
                {renderField(
                  "Raw Blood Spots Belly",
                  filletInformation?.filletDetails?.rawBloodSpotsBelly,
                  filletInformation?.filletDetails?.rawBloodSpotsBelly,
                  getMonitorAverage?.RawBloodSpotsBelly,
                  "cm²"
                )}
                {renderField(
                  "Raw Blood Spots Tail",
                  filletInformation?.filletDetails?.rawBloodSpotsTail,
                  filletInformation?.filletDetails?.rawBloodSpotsTail,
                  getMonitorAverage?.RawBloodSpotsTail,
                  "cm²"
                )}
                {renderField(
                  "Raw Largest Blood Spot",
                  filletInformation?.filletDetails?.rawLargestBloodSpot,
                  filletInformation?.filletDetails?.rawLargestBloodSpot,
                  getMonitorAverage?.RawLargestBloodSpot,
                  "cm²"
                )}
                {renderField(
                  "Raw Gaping Loin",
                  filletInformation?.filletDetails?.rawGapingLoin,
                  filletInformation?.filletDetails?.rawGapingLoin,
                  getMonitorAverage?.RawGapingLoin,
                  "cm²"
                )}
                {renderField(
                  "Raw Gaping Belly",
                  filletInformation?.filletDetails?.rawGapingBelly,
                  filletInformation?.filletDetails?.rawGapingBelly,
                  getMonitorAverage?.RawGapingBelly,
                  "cm²"
                )}
                {renderField(
                  "Raw Gaping Tail",
                  filletInformation?.filletDetails?.rawGapingTail,
                  filletInformation?.filletDetails?.rawGapingTail,
                  getMonitorAverage?.RawGapingTail,
                  "cm²"
                )}
                {renderField(
                  "Raw Largest Gaping",
                  filletInformation?.filletDetails?.rawLargestGaping,
                  filletInformation?.filletDetails?.rawLargestGaping,
                  getMonitorAverage?.RawLargestGaping,
                  "cm²"
                )}
                {renderField(
                  "Colour Loin",
                  filletInformation?.filletDetails?.colorLoin,
                  filletInformation?.filletDetails?.colorLoin,
                  getMonitorAverage?.ColorLoin
                )}
                {renderField(
                  "Colour Belly",
                  filletInformation?.filletDetails?.colorBelly,
                  filletInformation?.filletDetails?.colorBelly,
                  getMonitorAverage?.ColorBelly
                )}
                {renderField(
                  "Colour Tail",
                  filletInformation?.filletDetails?.colorTail,
                  filletInformation?.filletDetails?.colorTail,
                  getMonitorAverage?.ColorTail
                )}
                {renderField(
                  "Fillet Colour",
                  filletInformation?.filletDetails?.filletColor,
                  filletInformation?.filletDetails?.filletColor,
                  getMonitorAverage?.FilletColor
                )}
                {renderField(
                  "Red Skin Wounds",
                  filletInformation?.filletDetails?.redSkinWounds,
                  filletInformation?.filletDetails?.redSkinWounds,
                  getMonitorAverage?.RedSkinWounds
                )}
                {renderField(
                  "White Skin Wounds",
                  filletInformation?.filletDetails?.whiteSkinWounds,
                  filletInformation?.filletDetails?.whiteSkinWounds,
                  getMonitorAverage?.WhiteSkinWounds,
                  "cm²"
                )}
                {renderField(
                  "Grown Skin Wounds",
                  filletInformation?.filletDetails?.grownSkinWounds,
                  filletInformation?.filletDetails?.grownSkinWounds,
                  getMonitorAverage?.GrownSkinWounds,
                  "cm²"
                )}
                {renderField(
                  "Skin Leftovers",
                  filletInformation?.filletDetails?.skinleftovers,
                  filletInformation?.filletDetails?.skinleftovers,
                  getMonitorAverage?.Skinleftovers,
                  "cm²"
                )}
                {renderField(
                  "Skinned",
                  filletInformation?.filletDetails?.skinned,
                  filletInformation?.filletDetails?.skinned,
                  getMonitorAverage?.Skinned
                )}
                {renderField(
                  "Width Brown Fat",
                  filletInformation?.filletDetails?.widthBrownFat,
                  filletInformation?.filletDetails?.widthBrownFat,
                  getMonitorAverage?.WidthBrownFat,
                  "cm"
                )}
                {renderField(
                  "Sequence No",
                  filletInformation?.filletDetails?.sequenceNo,
                  filletInformation?.filletDetails?.sequenceNo,
                  getMonitorAverage?.SequenceNo
                )}
                {/* {renderField(
                  "Valid From UTC",
                  filletInformation?.filletDetails?.validFromUTC.split("T")[0],
                  filletInformation?.filletDetails?.validFromUTC.split("T")[0]
                )} */}
              </tbody>
            </table>
          </div>
        </>
        {/* {colorGradingInfo && ( */}
        {/* <div className="w-full rounded-md bg-red-400 justify-center items-center overflow-hidden mt-3 border dark-bg"> */}
        {/* <div
          style={{ display: colorGradingInfo ? "flex" : "none" }}
          className="w-full flex items-center justify-center dark-bg"
        >
          <CustomMemooizedLabelCenter colorGradingRatio={colorGradingInfo} />
        </div> */}
        {/* </div> */}
        {/* )} */}
      </div>
    </React.Fragment>
  );
};

export default FilletInformationList;
